import { Label } from "components/atoms/form"

export const TextArea = ({
  label,
  register,
  required = false,
  type = "textarea",
  placeholder = "",
  errors = [""],
  name,
  defaultValue = "",
  rows = 5,
}) => (
  <div className="block w-full sm:inline-flex">
    <div className="w-full">
      <Label label={label} required={required} error={errors?.[name]} />
      <textarea
        className="focus:shadow-outline block w-full appearance-none rounded-lg border border-zinc-300 bg-white px-3 py-2 leading-normal text-zinc-800 focus:outline-none"
        {...register(name, { required })}
        placeholder={placeholder}
        type={type}
        defaultValue={defaultValue}
        rows={rows}
      />
    </div>
  </div>
)
